export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/piano-icon.svg?e906b53e9b6537dc04156bf3f7a977c7";